(function () {
  var marqueeSelector = ".product__badges-sale-scrolling";
  var styleId = "la-mobile-audit-fixes-style";
  var raf = window.requestAnimationFrame || function (callback) { return window.setTimeout(callback, 16); };

  function injectStyle() {
    if (document.getElementById(styleId)) return;
    var style = document.createElement("style");
    style.id = styleId;
    style.textContent = ".product__badges-sale-scrolling{display:none!important}.product__badges-sale-scrolling .animation-marquee{animation:none!important}";
    document.head.appendChild(style);
  }

  function removeSaleMarquees() {
    var marquees = document.querySelectorAll(marqueeSelector);
    Array.prototype.forEach.call(marquees, function (marquee) {
      if (marquee && marquee.parentNode) {
        marquee.parentNode.removeChild(marquee);
      }
    });
  }

  function isUsableElement(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    var style = window.getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && style.display !== "none" && style.visibility !== "hidden";
  }

  function getStickyTrigger(sticky) {
    var main = sticky.closest(".sec__featured-product") || document.querySelector(".sec__featured-product") || document;
    var selectors = [
      ".button-trigger__sticky .product-group-submit",
      ".button-trigger__sticky .product-form__submit",
      ".button-trigger__sticky button[name='add']",
      ".button-trigger__sticky .shopify-payment-button__button",
      ".button-trigger__sticky"
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var matches = main.querySelectorAll(selectors[i]);
      for (var j = 0; j < matches.length; j += 1) {
        if (isUsableElement(matches[j])) {
          return matches[j];
        }
      }
    }
    return null;
  }

  function isFooterClose() {
    var footer = document.querySelector(".product-sticky-hide");
    return footer && footer.getBoundingClientRect().top < window.innerHeight - 100;
  }

  function syncStickyBar(sticky) {
    var trigger = getStickyTrigger(sticky);
    if (!trigger || isFooterClose()) {
      sticky.classList.remove("show-sticky-cart");
      return;
    }
    sticky.classList.toggle("show-sticky-cart", trigger.getBoundingClientRect().bottom <= 0);
  }

  function bindStickyBar(sticky) {
    if (sticky.dataset.laAuditStickyFix === "ready") return;
    sticky.dataset.laAuditStickyFix = "ready";

    var ticking = false;
    var update = function () {
      if (ticking) return;
      ticking = true;
      raf(function () {
        ticking = false;
        syncStickyBar(sticky);
      });
    };

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    window.setTimeout(update, 0);
    window.setTimeout(update, 700);
    window.setTimeout(update, 2000);
  }

  function initStickyBars() {
    var stickyBars = document.querySelectorAll("sticky-add-cart");
    Array.prototype.forEach.call(stickyBars, function (sticky) {
      bindStickyBar(sticky);
      syncStickyBar(sticky);
    });
  }

  function cleanup() {
    injectStyle();
    removeSaleMarquees();
    initStickyBars();
  }

  function startObserver() {
    if (!window.MutationObserver) return;
    var target = document.body || document.documentElement;
    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      raf(function () {
        pending = false;
        cleanup();
      });
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  cleanup();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", cleanup, { once: true });
  }
  window.addEventListener("load", cleanup, { once: true });
  document.addEventListener("shopify:section:load", cleanup);
  startObserver();
})();
